<template>
  <div>
    <el-menu :default-active="activeIndex" class="el-header-menu" mode="horizontal" @select="handleSelect">
      <el-submenu index="2">
        <template slot="title"><span><i class="el-icon-user"></i> 欢迎您：{{ userInfo.nickname }} </span></template>
        <el-menu-item index="2-1"><i class="el-icon-lock"></i> 修改密码</el-menu-item>
        <el-menu-item index="2-2"><i class="el-icon-switch-button"></i> 退出登录</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tishi: true,
      activeIndex: '1',
      userInfo: {}
    };
  },
  props: ["menuall"],
  created() { },
  mounted() {
    this.userInfo = this.$store.state.user;
  },
  methods: {
    handleSelect(key, keyPath) {
      if (key == '2-2') {
        this.exit()
      } else if (key == '2-1') {
        this.$router.push({ path: '/managers/password' })
      }
    },
    //退出
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout')

            localStorage.removeItem('token')
            localStorage.removeItem('menuall')
            localStorage.removeItem('menuid')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 500)

        })
        .catch(() => {
        })
    }
  },
};
</script>
<style>
.item {
  margin-top: 10px;
  margin-right: 40px;
}

.el-header-menu {
  display: flex;
  justify-content: flex-end;
}

.div_menu {
  float: left;
  /* width: 240px; */
  height: 61px;
  font-size: 24px;
  font-weight: 900;
  line-height: 61px;
  margin-left: 20px;
}

.div_menu>img {
  margin-top: 13px;
  width: 200px !important;
  height: 47px !important;
}

.right {
  float: right;
  line-height: 61px;
  font-size: 20px;

  margin-right: 20px;
  cursor: pointer;
}

.right span {
  font-size: 16px;
  color: #474646;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue